module.exports = __webpack_public_path__ + "static/media/instagram-gradient.5ffc4044.svg";